import { useQuery } from "@tanstack/react-query";

import { useApi } from "@/shared/api/use-api";

type Params = {
  userId?: number;
  sessionId?: string;
  xStatId?: string;
  yStatId?: string;
  zStatId?: string;
};

export const useGetChartData = ({ userId, sessionId, xStatId, yStatId, zStatId }: Params) => {
  const { statsControllerApi } = useApi();

  return useQuery({
    queryKey: [`getChartData`, userId, sessionId, xStatId, yStatId, zStatId],
    queryFn: ({ signal }) => {
      return statsControllerApi.querySessionStatsFull(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        userId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        sessionId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xStatId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        yStatId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        zStatId!,
        {
          signal,
        }
      );
    },
    enabled: !!sessionId && !!userId && !!xStatId && !!yStatId && !!zStatId,
    retry: 0,
  });
};
